<template>
  <b-modal :title="title" :hide-footer="noFooter" :ref="reference" @ok="clickOK" @ok-disabled="okDisabled" @cancel="clickCancel" :size="size">
    <b-container fluid>
      <slot name="body"></slot>
    </b-container>
      <div v-if="this.customizationCheck('footer')" slot="modal-footer" class="w-100">
         <slot name="footer"></slot>
       </div>
  </b-modal>
</template>
<script type="text/javascript">
export default {
  name: 'FITModal',
  props: {
    title: {
      type: String,
      required: true
    },
    noFooter: Boolean,
    reference: String,
    size: String,
    shownCallback: Function,
    shouldPreventDefault: { type: Boolean, default: false },
    customizedSessions:Array
  },
  data() {
    return {
      okDisabled: false,
    }
  },
  methods: {
    customizationCheck(session){
      if(!this.customizedSessions){
        return false;
      }
      return this.customizedSessions.includes(session);
    },

    openModal(){
      this.$refs[this.reference].show();
    },
    closeModal(){
      this.$refs[this.reference].hide();
    },
    clickOK(evt){
      // this.okDisabled =  true;
      if (this.shouldPreventDefault) {
        evt.preventDefault()
      }
      this.$emit('click', true);
    },
    clickCancel() {
      this.$emit('click', false);

    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Form/FITModal.vue